import React, { useEffect, useState } from 'react';
import Colors from '../constants/colors';
import { BettorSearchApi } from './api';
import type { EventProps, PublicPlayerProps, TournamentProps } from '../types';
import { Button, TextInput, View } from '../Components/Themed';
import { Icons } from '../Components';

type BettorSearchProps = {
    search_types:string[],
    init_search_value?:string,
    container_style?:any,
    search_style?:any,
    button_style?:any,
    onSearchResults:(results: {
        offset:number,
        players:PublicPlayerProps[],
        events:EventProps[],
        tournaments:TournamentProps[]
        competitions:any[],
        polls: any[]
    }) => void,
}

const BettorSearch = ({ init_search_value, search_types, onSearchResults }:BettorSearchProps) => {
    const [ search, setSearch ] = useState({
        search_value: '',
        offset:0
    });

    const { search_value, offset } = search;

    useEffect(() => { 
        BettorSearchApi.setEnvironment() 
        if(init_search_value){
            handleSearch(init_search_value)
        }
    },[init_search_value])

    const handleSearch = async(value?:string) => {
        if(!value){ value = search_value }
        let players:PublicPlayerProps[] = []
        let events:EventProps[] = []
        let tournaments:TournamentProps[] = []
        let competitions:any[] =[]
        let polls: any[] = []
        const performSearches = search_types.map(async t => {
            try {
                switch(t){
                    case 'players': 
                        console.log('in here!')
                        return players = await BettorSearchApi.searchPlayers(value, offset)
                    case 'events':
                        return events = await BettorSearchApi.searchEvents(value, offset);
                    case 'tournaments':
                        return tournaments = await BettorSearchApi.searchTournaments(value, offset);
                    default: return
                }
            } catch (e) {
                return
            }
        })
        await Promise.all(performSearches)

        onSearchResults({
            offset,
            players,
            events,
            tournaments,
            competitions,
            polls
        })
    }

    return (
        <View style={{ padding:10, flexDirection:'row', alignItems:'center' }}>
            <View transparent style={{ padding:10 }}>
                <Icons.SearchIcon 
                    color={Colors.brand.midnight}
                    size={18}
                />
            </View>
            <TextInput
                placeholder='Search...'
                style={{ flex:1, marginRight:10 }}
                placeholderTextColor={Colors.brand.slate}
                value={search_value}
                onChangeText={(text) => setSearch({ ...search, search_value:text })}
            />
            <Button
                title='Search'
                type='action'
                onPress={() => handleSearch()}
            />
        </View>
    )
}

export default BettorSearch